import { useQuery } from '@tanstack/react-query';
import { fetchServices } from '../services/smr-admin';
import type { ServiceListParams } from '../services/smr-admin';

export const serviceKeys = {
    all: ['smr-admin', 'services'] as const,
    lists: () => [...serviceKeys.all, 'list'] as const,
    list: (params: ServiceListParams) => [...serviceKeys.lists(), params] as const,
    detail: (id: string) => [...serviceKeys.all, 'detail', id] as const,
};

export const serviceItemsQueryKeyRoot = ['smr-admin', 'service-items'] as const;

export const useServicesQuery = (params: ServiceListParams = {}) =>
    useQuery({
        queryKey: serviceKeys.list(params),
        queryFn: () => fetchServices(params),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
